import React, { useState, useEffect, ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import PanelTextWithHeader from '../../../atoms/panels/PanelTextWithHeader';
import EditableTextarea from '../../../atoms/EditableTextarea';
import { updateProfileSeeking } from '../../../actions/profileActions';
import { FONT_FAMILIES } from 'theme/material/constants';
import { getTextColor } from 'style';

interface IFirstDateProps {
  seeking: string;
  editable: boolean;
  isProcessing: boolean;
  themeDarkMode?: boolean;
}

const FirstDate = (props: IFirstDateProps): ReactElement => {
  const { seeking, editable, isProcessing, ...rest } = props;
  const [editFirstDate, setEditFirstDate] = useState<boolean>(false);
  const [firstDate, setFirstDate] = useState<string>('');
  const dispatch = useDispatch();

  useEffect(() => {
    setFirstDate(seeking);
    return () => {
      setEditFirstDate(false);
    };
  }, [seeking]);

  const toggleEditable = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    e.preventDefault();
    setEditFirstDate(!editFirstDate);
  };

  const updateFirstDate = (value: string): void => {
    setFirstDate(value);
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    dispatch(
      updateProfileSeeking({
        seeking: firstDate,
      })
    );
    toggleEditable(e);
  };

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    // need to clear the fields if user select cancel button
    toggleEditable(e);
    setFirstDate(seeking);
  };

  return (
    <div>
      {editFirstDate ? (
        <EditableTextarea
          className="profile__first-date"
          title="My ideal first date"
          value={firstDate}
          handleCancel={handleCancel}
          handleSubmit={handleSubmit}
          updateValue={updateFirstDate}
          id={'seeking'}
          minCount={50}
          placeholder="Dinner, drinks and going for a walk after? What's your ideal first date?"
          customStyle={{ paddingBottom: 20 }}
          isProcessing={isProcessing}
          panelStyle="borderless"
          customTitleStyle={{
            fontWeight: 400,
            fontFamily: FONT_FAMILIES.secondary,
            lineHeight: '20px',
            letterSpacing: -0.2,
            ...getTextColor().DARK_4,
          }}
        />
      ) : (
        <PanelTextWithHeader
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          className="profile__first-date"
          title="My ideal first date"
          editable={editable}
          content={firstDate}
          toggleEditable={toggleEditable}
          isProcessing={isProcessing}
          dataTestId="edit-seeking-info"
          panelStyle="borderless"
          minCount={50}
          customTitleStyle={{
            fontWeight: 400,
            fontFamily: FONT_FAMILIES.secondary,
            lineHeight: '20px',
            letterSpacing: -0.2,
            ...getTextColor().DARK_4,
          }}
          {...rest}
        />
      )}
    </div>
  );
};

export default React.memo(FirstDate);
